const CyanDot = () => {
  return (
    <div className="relative w-34 h-34 sm:w-43 sm:h-43 rounded-full bg-cyan | color-circle-1-js">
      <svg
        className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-19 h-auto"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.2485 13.2483H5.07645L3.07995 2.27112C3.05659 2.13966 2.98801 2.0205 2.88609 1.93426C2.78416 1.84801 2.6553 1.80011 2.52178 1.79883H1.22656"
          stroke="white"
          strokeWidth="0.872341"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.80618 16.1104C6.5966 16.1104 7.23737 15.4697 7.23737 14.6792C7.23737 13.8888 6.5966 13.248 5.80618 13.248C5.01576 13.248 4.375 13.8888 4.375 14.6792C4.375 15.4697 5.01576 16.1104 5.80618 16.1104Z"
          stroke="white"
          strokeWidth="0.872341"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2476 16.1104C14.038 16.1104 14.6788 15.4697 14.6788 14.6792C14.6788 13.8888 14.038 13.248 13.2476 13.248C12.4572 13.248 11.8164 13.8888 11.8164 14.6792C11.8164 15.4697 12.4572 16.1104 13.2476 16.1104Z"
          stroke="white"
          strokeWidth="0.872341"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.55323 10.3868H13.5411C13.8087 10.3877 14.068 10.2941 14.2735 10.1227C14.479 9.95123 14.6174 9.71284 14.6645 9.44942L15.5376 4.66211H3.51562"
          stroke="white"
          strokeWidth="0.872341"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export default CyanDot;
